// extracted by mini-css-extract-plugin
module.exports = {"dot":"_3bO_k","active":"_3sUi1","container":"Xa7xK"};